import { Grid, MenuItem, TextField } from "@mui/material";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import { complainMinStatuses } from "../../../app/config/complainStatuses";

function ComplainStatusForm({ onUpdate, isEditRequested, model}) {
    const { t } = useTranslation('ComplainDetailsScreen', { keyPrefix: 'StatusForm' });
    const [editEnabled, setEditEnabled] = React.useState(false);
    const [internalModel, setInternalModel] = useState(model);
    const statusRef = useRef(null);

    const getStatus = (source) => {
        if (!source)
            return 0;

        if(source.transferredToGestalUtc !== null) {
            if(source.status === 1) {
                return source.isResolved ? (source.resolvedByGestal ? 1 : 4) : 5;
            }

            return 2;
        }

        if (source.isClosedAutomatically && source.isResolved) return 8;
        if (source.isClosedAutomatically && !source.isResolved) return 9;

        if (source.isDraft || source.status === 3) return 3;
        if (source.status === 1 && source.isResolved) return 4;
        if (source.status === 1 && !source.isResolved) return 5;


        return 0;
    }
    
    
    const [status, setStatus] = useState(getStatus(model));

    useEffect(() => {
        console.log('[complainStatusForm] 🚀 ', JSON.stringify(model, null, 2));
    }, [model]);
    
    useEffect(() => {
        setInternalModel(model);
        setStatus(getStatus(model));
        setEditEnabled(false);
    }, [model]);

    const handleStatusUpdate = async () => {
        if(internalModel.status === status) {
            setEditEnabled(false);
            return;
        }
        
        await handleUpdate('Status', status);
    }

    const handleUpdate = async (name, value) => {
        await onUpdate(name, value, true);

        setEditEnabled(false);
    }

    useEffect(() => {
        if (isEditRequested) {
            setEditEnabled(true);
            statusRef.current.focus();
        }
    }, [isEditRequested]);

    // useEffect(() => {
    //     setStatus(getStatus());
    // }, [model.status, getStatus])

    const setComplaintStatus = (value) => {
        setStatus(value);
        setInternalModel(prev => ({...prev, isClosedAutomatically: false}))
    }

    return (
        <div className="fk-form-section">
            <Grid container spacing={2}>
                <Grid item md={3} className="fk-label">
                    <label>{t('status')}</label>
                </Grid>
                <Grid item md={8} className="fk-input-container">
                    <TextField
                        ref={statusRef}
                        fullWidth
                        select={!!complainMinStatuses}
                        disabled={!editEnabled}
                        className="fk-input"
                        value={status ?? ''}
                        onChange={(event) => setComplaintStatus(event?.target?.value)}
                    >
                        {complainMinStatuses && complainMinStatuses.map(({value, text, disabled, disabledAfterTransfer}) => {
                            const isTransferred = internalModel.transferredToGestalUtc !== null;
                            
                            let shouldDisableAfterTransfer = disabledAfterTransfer && isTransferred;
                            
                            return (
                                <MenuItem key={value} value={value} disabled={disabled || shouldDisableAfterTransfer}> 
                                    {t(text)}
                                </MenuItem>
                            )
                        })}
                    </TextField>
                </Grid>
                <Grid item md={1}>
                    {!editEnabled
                        ? <button
                            className="fk-edit-button"
                            onClick={() => setEditEnabled(true)}
                        >
                            <EditIcon />
                        </button>
                        : <button
                            className="fk-edit-button"
                            onClick={() => handleStatusUpdate()}
                        >
                            <SaveIcon />
                        </button>
                    }
                </Grid>
                {internalModel.status === 1 &&
                    <>
                        <Grid item md={3} className="fk-label">
                            <label>{t('isResolved')}</label>
                        </Grid>
                        <Grid item md={9} style={{display: 'flex', alignItems: 'flex-end', lineHeight: '17px'}}>
                            {internalModel.isResolved ? t('yes') : t('no')}
                        </Grid>
                    </>
                }
                {internalModel.consumerComment &&
                    <>
                        <Grid item md={3} className="fk-label">
                            <label>{t('consumerComment')}</label>
                        </Grid>
                        <Grid item md={9} style={{display: 'flex', alignItems: 'flex-end', lineHeight: '17px'}}>
                            {internalModel.consumerComment}
                        </Grid>
                    </>
                }

            </Grid>
        </div>
    );
}

export default ComplainStatusForm;
